module.exports = "https://portperrypedals.ca/_res/img/martyn.65bb428.png";